import { createContext } from 'react'
import type {
  GenerationModelDetailFragment,
  GenerationModelVersionDetailFragment,
} from 'src/services/apollo/generated/graphql'

export const ModelDetailContext = createContext<{
  model?: GenerationModelDetailFragment
  loadingModel: boolean
  mutateModel: () => void
  version?: GenerationModelVersionDetailFragment
  loadingVersion?: boolean
  mutateVersion: () => void
  isSinglePage?: boolean
  /** Sticky "Use this model" footer callback; replaces in-page action on mobile. */
  onUse?: () => void
  onClose?: () => void
}>(
  // `never` is to skip type checking for `undefined`s.
  // Otherwise, we have to initialize every non-nullable prop, which is
  // meaningless anyway.
  undefined as never,
)
